var _defs, _use;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEducation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.062 14.092c-.584.337-1.54.337-2.124 0-.584-.337-.584-.89 0-1.226.584-.337 1.54-.337 2.124 0 .584.337.584.889 0 1.226m10.493-1.005c.593.216.593.569 0 .785l-.54.196v6.52a1.125 1.125 0 11-2.25 0v-5.702c-.266.097-.553.2-.847.308l-3.293 1.197-2.466.898a797.1 797.1 0 00-1.08.392l.106-.039-.106.039-.54.196a1.838 1.838 0 01-1.079 0l-.539-.196-1.08-.392-3.079-1.12c-.593-.217-1.565-.57-2.158-.785l-4.158-1.512c-.594-.216-.594-.57 0-.785l4.158-1.512 2.158-.786 3.079-1.119 1.08-.393.54-.196a1.85 1.85 0 011.078 0l.54.196.317.115-.231-.084.994.362 3.078 1.12-1.07-.39 2.816 1.024 2.159.785 2.413.878zm-5.42 5.006l.757-.276v2.77c-.001 1.022-.672 2.043-2.013 2.817-.076.044-.166.074-.245.116-1.005.44-2.276.855-3.683.994-.632.05-1.27.05-1.902 0-1.407-.139-2.68-.554-3.683-.995-.079-.04-.169-.07-.245-.115-1.341-.775-2.012-1.796-2.012-2.817v-2.77l.745.271 1.714.624 2.273.827a1480.083 1480.083 0 001.62.588c.296.108.782.108 1.078 0h.001l.54-.196.006-.002 1.073-.39 3.976-1.446z",
    id: "a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#7B98B6",
    xlinkHref: "#a",
    transform: "translate(-5 -9)",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/Education.885495e74bc7d53c89923982e7458cf1.svg";
export { ForwardRef as ReactComponent };